import React from "react";

/**
 * Standard page shell: consistent max width, horizontal padding, vertical
 * rhythm and a subtle mount animation. The bottom padding clears the fixed
 * navigation pill so content is never hidden behind it.
 */
export default function Page({ children, className = "" }) {
  return (
    <main
      className={`mx-auto flex w-full max-w-content flex-col px-5 pb-12 pt-16 sm:pt-24 animate-fade-up ${className}`}
    >
      {children}
    </main>
  );
}
